
































import Vue from 'vue';
import ItemIconTooltip from '@/old/items/ItemIconTooltip.vue';
import ICashShopEntry, { CashCommodityType } from '@/models/items/ICashShop';

export default Vue.extend({
    components: {
        ItemIconTooltip,
    },
    props: {
        entry: {
            type: Object as () => ICashShopEntry,
            required: true,
        },
        origin: {
            type: String,
            default: '',
        },
    },
    computed: {
        techMode(): boolean {
            return this.$store.state.techMode;
        },
        isPackage(): boolean {
            return this.entry.type === CashCommodityType.Package
                || this.entry.type === CashCommodityType.DolisPackage;
        },
    },
});
